import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, LoggerService, SecurityService, saveFile, uniqueBlobFileName } from 'saker-core';
import { ProjectScenarioPageDTO } from '../Protocol/projectScenarioPage.dto';
import { Observable, catchError } from 'rxjs';
import { ProjectScenarioDTO } from '../Protocol/projectScenario.dto';

@Injectable({
  providedIn: 'root'
})
export class ProjectScenarioService {

  constructor(
    private configuration: ConfigurationService,
    private http: HttpClient,
    private logger: LoggerService,
    private security: SecurityService
  ) { }


  //   function getData(response) {
  //     return response.data;
  // }

  // function reject(response) {
  //     if (response && response.data) {
  //         if (response.data.Message) {
  //             return $q.reject(response.data.Message);
  //         }
  //         else {
  //             return $q.reject(response.data);
  //         }
  //     }
  //     else {
  //         return $q.reject('Service Unavailable');
  //     }
  // }

  deleteProjectScenario(mnenomic: string, id: string) {

    return new Observable((observer) => {
      let url = this.configuration.CONFIG.BASE_URL + '/' + mnenomic + '/remove/' + id;

      console.info(url);

      return this.http.delete(url, { withCredentials: true }).pipe(
        catchError(error => this.logger.handleError(error))).subscribe((response) => {
          let url = this.configuration.CONFIG.BASE_URL + "/dsm/remove/" + id;

          return this.http.delete(url, { withCredentials: true }).subscribe((response) => {
            observer.next(response)
            observer.complete()
          })
        })

    })

    // return $http.delete(url, config)
    //     .then(onSuccess)
    //     .catch(reject);

    // function onSuccess(response) {

    //     let url = sakerConfig.BASE_URL + "/dsm/remove/" + id;
    //     let config = {
    //         withCredentials: true,
    //     };

    //     return $http.delete(url, config)
    //         .then(getData)
    //         .catch(reject);
    // }

  }

  getProjectScenariosPaged(filter: any) {

    filter.size = this.configuration.CONFIG.PAGE_SIZE;

    let qs = this.serialise(filter);

    let url = this.configuration.CONFIG.BASE_URL + '/dsm/projectScenarios/paged?' + qs;

    return this.http.get<ProjectScenarioPageDTO>(url, { withCredentials: true }).pipe(
      catchError(error => this.logger.handleError(error)));

  }

  serialise(obj: any): URLSearchParams {
    let params: URLSearchParams = new URLSearchParams();

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        var element = obj[key];

        if (element)
          params.set(key, element);
      }
    }
    return params;
  }

  // function getProjectScenarios(mnemonic) {
  //     let url = sakerConfig.BASE_URL + '/dsm/projectScenarios/' + mnemonic;
  //     let config = {
  //         withCredentials: true
  //     };

  //     return $http.get(url, config)
  //         .then(getData)
  //         .catch(reject);
  // }

  getProjectScenarioCSV(mnenomic: string, id: string) {

    return new Observable((observer) => {
      let url = this.configuration.CONFIG.BASE_URL + '/' + mnenomic + '/download/' + id;

      console.info(url);

      return this.http.get(url, { responseType: 'blob', withCredentials: true, observe: 'response' }).pipe(
        catchError(error => this.logger.handleError(error)))
        .subscribe((response: any) => {

          var filename = response.headers.get('x-filename');

          saveFile(response.body, uniqueBlobFileName(filename));

          this.logger.information('Downloading file \'' + filename + '\'.');

          observer.next()
          observer.complete()

        })
    })

    // let config = {
    //     responseType: 'blob',
    //     withCredentials: true,
    // };

    // return $http.get(url, config)
    //     .then(onSuccess)
    //     .catch(reject);

    // function onSuccess(response) {

    //     let headers = response.headers();

    //     var filename = headers['x-filename'];
    //     var contentType = headers['content-type'];

    //     logger.info('Downloading file \'' + filename + '\'.');

    //     var blob = new Blob([response.data], {
    //         type: 'application/octet-stream'
    //     });

    //     if (navigator.msSaveBlob) {
    //         navigator.msSaveBlob(blob, filename); // IE 11
    //     }
    //     else {
    //         let tempLink = document.createElement('a');
    //         tempLink.href = window.URL.createObjectURL(blob);
    //         tempLink.setAttribute('download', filename);
    //         tempLink.click();
    //     }

    //     return response;
    // }

  }

  getProjectScenario(id: string) {
    let url = this.configuration.CONFIG.BASE_URL + "/dsm/projectScenario/" + id;

    return this.http.get<ProjectScenarioDTO>(url, { withCredentials: true }).pipe(
      catchError(error => this.logger.handleError(error)));
  }

  importProjectScenario(mnemonic: string, file: File) {
    let url = this.configuration.CONFIG.BASE_URL + "/" + mnemonic + "/import";

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<ProjectScenarioDTO>(url, formData, { withCredentials: true }).pipe(
      catchError(error => this.logger.handleError(error)));
  }



}
